import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicFourierPeriodic = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="FOURIER SERIES FOR PERIODIC FUNCTIONS"
      videos={[
        "https://www.youtube.com/embed/KCS-VTm398I?list=PLhSp9OSVmeyLke5_cby8i8ZhK8FHpw3qs",
        "https://www.youtube.com/embed/woiMkvIWT18?list=PLhSp9OSVmeyLke5_cby8i8ZhK8FHpw3qs",
        "https://www.youtube.com/embed/-qB9BnOguHE?list=PLhSp9OSVmeyLke5_cby8i8ZhK8FHpw3qs"
      ]}
      takeaways={[]}
      questions={[]}
      exampleVideos={[]}
    />
);
}

export default ModuleSubtopicFourierPeriodic;